<div id="loader-style-estetista"
    class="flex items-center place-content-center fixed top-0 left-0 z-[99999] bg-white w-screen h-screen">
    <div class="w-fit">
        <img class="mx-auto w-[250px] blur-[10px] trans-duration-loader" [ngClass]="{'!blur-0': disableBlurImg}"
            [src]="'../assets/logoAuth.png'" />
        <div class="w-[250px] h-[5px] rounded-full bg-[#7A6F9B] !bg-opacity-35">
            <div id="loader-bar-estetista" class="h-[5px] rounded-full trans-duration-loader bg-[#7A6F9B]"></div>
        </div>
    </div>
</div>

<router-outlet></router-outlet>